import type { ReactNode } from 'react'
import { Clock, Star } from 'lucide-react'
import { Chip, type ChipTone } from '../primitives/Chip'

export interface Suggestion {
  command: string
  tone: ChipTone
}

export interface StartSuggestionsProps {
  favorites: Suggestion[]
  recent: Suggestion[]
  onPick: (command: string) => void
}

export function StartSuggestions({ favorites, recent, onPick }: StartSuggestionsProps) {
  return (
    <div className="flex flex-1 flex-col justify-center px-5 py-8">
      <h2 className="mb-7 text-center text-xl font-bold text-neutral-900">
        Starte mit diesen Prompts
      </h2>
      <div className="space-y-6">
        {favorites.length === 0 && recent.length === 0 && (
          // Nothing loaded (yet) — still tell the user how to get going.
          <p className="text-center text-sm text-neutral-500">
            Tippe <span className="font-mono font-semibold text-neutral-700">/</span> im
            Eingabefeld, um einen Prompt oder Skill zu wählen.
          </p>
        )}
        {favorites.length > 0 && (
          <Section icon={<Star className="h-3.5 w-3.5 text-amber-400" />} title="Favoriten">
            {favorites.map((s) => (
              <Chip key={s.command} tone={s.tone} onClick={() => onPick(s.command)}>
                {s.command}
              </Chip>
            ))}
          </Section>
        )}
        {recent.length > 0 && (
          <Section
            icon={<Clock className="h-3.5 w-3.5 text-neutral-400" />}
            title="Zuletzt verwendet"
          >
            {recent.map((s) => (
              <Chip key={s.command} tone={s.tone} onClick={() => onPick(s.command)}>
                {s.command}
              </Chip>
            ))}
          </Section>
        )}
      </div>
    </div>
  )
}

function Section({
  icon,
  title,
  children,
}: {
  icon: ReactNode
  title: string
  children: ReactNode
}) {
  return (
    <div>
      <div className="mb-2.5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-neutral-400">
        {icon}
        {title}
      </div>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  )
}
